// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94877fc4","540":"aadfee8e","649":"bdad273e","783":"fb447bc1"}[chunkId] + ".chunk.js";
};